/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
import { paginationSchema } from '../models/core';
// Imported from the leaf module rather than the `../models` barrel to keep this cycle-free.
import { bidRequestProjectTeamRoleKeys, roleToSfLookupField, } from '../models/project-team-roles';
export const transformResultsSummary = (res) => ({
    rows: res.rows.map((result) => ({
        ...result.metrics,
        ...result.workflow,
        pvcosting_config: result.pvcosting_config ?? null,
        start_time: result.start_time,
        scenario_id: result.scenario_id,
        stage: result.stage,
        flow_name: result.flow_name,
    })),
    rowCount: res.count,
});
export const sfProjectTeamLookupFields = bidRequestProjectTeamRoleKeys.map((role) => roleToSfLookupField[role]);
export const projectTeamLookupFields = [
    'Id',
    'Name',
    ...sfProjectTeamLookupFields.map((x) => `${x}.Email`),
    ...sfProjectTeamLookupFields.map((x) => `${x}.Name`),
];
export const projectResultsQueryParamsSchema = paginationSchema.extend({
    bod: z.boolean().optional(),
    dl: z.enum(['xlsx']).optional(),
    selectedIds: z.string().nonempty().optional(),
});
export const projectWeatherQueryParamsSchema = paginationSchema.extend({
    radius: z.number().min(0).default(50000),
    showArchived: z.boolean().default(false),
    hasRainfall: z.boolean().default(false),
    bod: z.boolean().optional(),
});
//# sourceMappingURL=projects.js.map